import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getAllProductType = () => get(url.PRODUCT_TYPE_GET)
